<div class="logo">
    <cerrix-logo [width]="200" [height]="35"></cerrix-logo>
</div>
@if (!cellViewModels) {
    <cerrix-loader [cerrixTab]="tab"></cerrix-loader>
}
@if (printData) {
    <div class="print-name">
        <label class="lbl-big">
            {{ data.meta.processName }}
        </label>
    </div>
}
<div class="detail-page-card">
    <div class="detail-page-card-title">Process details</div>
    @if (printData) {
        <div class="detail-page-card-body padded form-group-styling">
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="controlNameInput">Process Name</label>
                        <input
                            class="form-control form-control-sm"
                            id="controlNameInput"
                            name="controlNameInput"
                            [ngModel]="data.meta.processName"
                            inputTooltip
                        />
                    </div>
                    <div class="form-group">
                        <label for="controlCatalogueSelect">Root</label>
                        <ng-select
                            id="controlCatalogueSelects"
                            name="controlCatalogueSelects"
                            bindLabel="processTextPath"
                            [items]="[data.meta]"
                            [(ngModel)]="data.meta"
                        >
                        </ng-select>
                    </div>
                    <div class="form-group">
                        <label for="controlCatalogueSelect">Author</label>
                        <ng-select
                            id="controlCatalogueSelect"
                            name="controlCatalogueSelect"
                            bindLabel="author"
                            [items]="[data.meta]"
                            [(ngModel)]="data.meta"
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="startDate">Date</label>
                        <date-input [value]="data.meta.date"></date-input>
                    </div>
                    <div class="form-group">
                        <label for="controlNameInput">Version</label>
                        <input
                            class="form-control form-control-sm"
                            id="controlNameInput"
                            name="controlNameInput"
                            [ngModel]="data.meta.version"
                            inputTooltip
                        />
                    </div>

                    <div class="form-group">
                        <label for="controlCatalogueSelect">Authorized by</label>
                        <ng-select
                            id="controlCatalogueSelect"
                            name="controlCatalogueSelect"
                            bindLabel="authorizedBy"
                            [items]="[data.meta]"
                            [(ngModel)]="data.meta"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="controlDescriptionInput">Description</label>
                    <div
                        class="form-control"
                        id="controlDescriptionInput"
                        name="controlDescriptionInput"
                        [rows]="4"
                        inputTooltip
                    >
                        {{ data.meta.processDescription }}
                    </div>
                </div>
                <div class="form-group col-12">
                    <label for="controlDescriptionInput">Comments</label>
                    <div
                        class="form-control"
                        id="controlDescriptionInput"
                        name="controlDescriptionInput"
                        inputTooltip
                    >
                        {{ data.meta.comment }}
                    </div>
                </div>
            </div>
        </div>
    }
</div>

<div class="detail-page-card pagebreak">
    <div class="detail-page-card-title">Process flow</div>
    <div class="detail-page-card-body padded flex-center flex-row">
        <print-process-flow [printGraph]="printData.graph"></print-process-flow>
    </div>
</div>

<div class="detail-page-card pagebreak">
    <div class="detail-page-card-title">Process steps</div>
    <div class="detail-page-card-body padded form-group-styling">
        @for (
            cellViewModel of cellViewModels;
            track cellViewModel;
            let last = $last;
            let index = $index
        ) {
            <div class="row pagebreak">
                <div class="col-12">
                    <div class="form-group">
                        <label for="controlNameInput" class="lbl-med"
                            >Step {{ index + 1 }}: {{ cellViewModel.processStep.label }}</label
                        >
                    </div>
                </div>
                <div class="col-12">
                    @if (cellViewModel.businessDimensionName) {
                        <div class="form-group">
                            <label for="controlNameInput">Linked process</label>
                            <input
                                class="form-control form-control-sm"
                                id="controlNameInput"
                                name="controlNameInput"
                                [ngModel]="cellViewModel.businessDimensionName"
                                inputTooltip
                            />
                        </div>
                    }
                </div>
            </div>
            <div class="row">
                <div class="form-group col">
                    <label for="controlDescriptionInput">Comment</label>
                    <div
                        class="form-control"
                        id="controlDescriptionInput"
                        name="controlDescriptionInput"
                        inputTooltip
                    >
                        {{ cellViewModel.processStep.comment }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    @if (cellViewModel.raciConfig) {
                        <generic-list-manager
                            [config]="cellViewModel.raciConfig"
                        ></generic-list-manager>
                    }
                </div>
            </div>
            @if (printOverviewModel) {
                <div class="row">
                    <div class="col">
                        @for (
                            linkedRiskConfig of cellViewModel.linkedRiskConfig;
                            track trackByName($index, linkedRiskConfig)
                        ) {
                            @if (isGraphRisksAndControls) {
                                <generic-list-manager [config]="linkedRiskConfig">
                                </generic-list-manager>
                            } @else {
                                <cerrix-table-multi-level [config]="linkedRiskConfig">
                                </cerrix-table-multi-level>
                            }
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        @for (
                            linkedControlConfig of cellViewModel.linkedControlConfig;
                            track linkedControlConfig
                        ) {
                            <generic-list-manager
                                [config]="linkedControlConfig"
                            ></generic-list-manager>
                        }
                    </div>
                </div>
            }
            @if (!last) {
                <hr />
            }
        }
    </div>
</div>

@if (
    printOverviewModel &&
    (!isGraphRisksAndControls ||
        unlinkedRiskConfig?.data?.length > 0 ||
        unlinkedControlConfig?.data?.length > 0)
) {
    <div class="detail-page-card pagebreak">
        <div class="detail-page-card-title">Not linked to a process step</div>
        <div class="detail-page-card-body padded">
            <div class="row">
                <div class="col">
                    @if (unlinkedRiskConfig) {
                        <generic-list-manager [config]="unlinkedRiskConfig"></generic-list-manager>
                    }
                </div>
            </div>
            <div class="row">
                <div class="col">
                    @if (unlinkedControlConfig) {
                        <generic-list-manager
                            [config]="unlinkedControlConfig"
                        ></generic-list-manager>
                    }
                </div>
            </div>
            <div class="row">
                <div class="col">
                    @if (unlinkedEventConfig.data) {
                        <generic-list-manager [config]="unlinkedEventConfig"></generic-list-manager>
                    }
                </div>
            </div>
            <div class="row">
                <div class="col">
                    @if (unlinkedMOIConfig.data) {
                        <generic-list-manager [config]="unlinkedMOIConfig"></generic-list-manager>
                    }
                </div>
            </div>
        </div>
    </div>
}

<div class="block-mouse"></div>
